import comp from "./SamlIdpResponseScreen";
export default comp;
